<template>
  <div>
    <div v-if="format == 'image'" class="img-block">
      <a :href="imgNormalizer" target="_blank" class="img-inside">
        <img :src="imgNormalizer" width="300" />
      </a>

      <el-button @click="drawer = true" class="btn-sm btn-primary"
        >Show source</el-button>

      <el-drawer
        title="Source"
        :closable="false"
        :visible.sync="drawer"
        placement="right"
        size="50%"
      >
        <span style="max-height: 500px; max-width: 300px">
          <pre style="overflow: auto">{{ value }}</pre>
        </span>
      </el-drawer>
    </div>
    <div v-else :title="value" @click="viewFullText" style="cursor: pointer">
      <pre>{{ shortText }}</pre>
      <el-dialog
        :visible.sync="showModal"
        title="Details"
        :show-close="true"
        append-to-body
      >
        <div>
          <pre style="overflow: auto">{{ this.value }}</pre>
        </div>
        <div slot="footer"></div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import * as utils from "@/utils.js";
export default {
  data() {
    return {
      drawer: false,
      showModal: false,
    };
  },
  mounted() {},
  props: ["value", "format", "result_id", "result_field", "task_id", "date", "loadDataURL"],
  methods: {
    viewFullText() {
      let that = this
      if (this.loadDataURL){
        utils
        .$get(this.loadDataURL)
        .then((response) => {
          if (response && response.status=="ok"){
            let result = response.result;
            that.value = result[that.result_field];
          }
          
          return
          const ignoredFields = ["_id"];
          if (response.error == null) {
            let data = response;
            if (data.results) {
              that.table.total = parseInt(data.total);
              that.resultsTotalRows = parseInt(data.total);
              let keys = [];
              // filter uniq titles
              for (var i in data.results) {
                let jone = data.results[i];
                // let jone = JSON.parse(one);
                let _keys = Object.keys(jone);
                for (let k in _keys) {
                  if (keys.indexOf(_keys[k]) === -1) keys.push(_keys[k]);
                }
              }

              let titles = [];
              for (var k in keys) {
                that.table.columns = [];
                if (!ignoredFields.includes(keys[k]))
                  titles.push({
                    title: keys[k].toUpperCase(),
                    key: keys[k],
                    prop: keys[k],
                    label: keys[k],
                    format: keys[k].includes(":image") ? "image" : "text",
                  });
              }
              that.table.columns = titles;
            }
            that.table.records = data.results;
            that.tableLoading = false;
          } else {
            alert("Error. Status Code: " + response.status);
            that.tableLoading = false;
            return;
          }
        })
        .catch(function (err) {
          console.log("Fetch Error :-S", err);
        });
      }
      
      let v = this.value;
      if (v.length > 100) 
      this.showModal = true;  
     //bus.$emit("dialog", this.value, "Source");
    },
  },
  computed: {
    shortText() {
      if (this.value) {
        if (this.value.length > 100 && this.format != "image") {
          return this.value.substr(0, 100) + "...";
        } else {
          return this.value;
        }
      }
      return "-";
    },
    imgNormalizer() {
      return this.value;
      if (
        typeof this.value == "string" &&
        this.value.match(/[0-9a-f]{32}.jpg/)
      ) {
        return `/tmp/${this.value}`;
      }
      return `/api/utils/html2img/?result_id=${this.result_id}&field=${this.result_field}&task_id=${this.task_id}&date=${this.date}`;
    },
  },
};
</script>
<style scoped>
pre {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/internal/ColumnRender.vue